import { useDispatch } from "react-redux";

import { ArrowsRepeatRegularV6 } from "@shared/v2/Icomoon";

import ActivityContainer from "./ActivityContainer";
import { activityCommonDefaultProps, activityCommonPropTypes, STYLES } from "../common";
import Header from "./Header";
import CategoryContainer from "./CategoryContainer";
import DataField from "./DataField";
import ActivityBtns from "./shared/ActivityBtns";

import { setCallParams } from "../../../../reducers/dialerReducer/dialerReducer";

const LeadTransferActivity = ({ activity, onReadChange }) => {
  const dispatch = useDispatch();

  return (
    <ActivityContainer activity={activity} onReadChange={onReadChange}>
      <Header
        category={
          <CategoryContainer
            containerClassName="tw-bg-[#FAF1E6] tw-text-[#AD6714]"
            Icon={ArrowsRepeatRegularV6}
          >
            Lead Transfer
          </CategoryContainer>
        }
        personName={`${activity.data?.subjectFirstName} ${activity.data?.subjectLastName}`}
        time={activity.createdAt}
        onReadChange={onReadChange}
        loading={activity.loading}
        read={activity.read}
      />
      <div className={`${STYLES.contentContainer} tw-text-14d`}>
        <DataField
          label="Transferred From"
          data={
            [activity.data?.secondarySubjectFirstName, activity.data?.secondarySubjectLastName]
              .filter(Boolean)
              .join(" ") || activity.data?.leadPondName
          }
        />
        {activity.data?.leadSource && <DataField label="Source" data={activity.data?.leadSource} />}
        <ActivityBtns
          callHandlr={() => {
            if (activity?.personUuid) {
              dispatch(
                setCallParams({ leadUuids: [activity.personUuid], callSource: "Lead Transfer Activity" }),
              );
            }
          }}
          containerClassName="!tw-mt-8px"
        />
      </div>
    </ActivityContainer>
  );
};

export default LeadTransferActivity;

LeadTransferActivity.propTypes = {
  ...activityCommonPropTypes,
};

LeadTransferActivity.defaultProps = {
  ...activityCommonDefaultProps,
};
